import find from "lodash/fp/find";
import flatMap from "lodash/fp/flatMap";
import flow from "lodash/fp/flow";
import getOr from "lodash/fp/getOr";
import has from "lodash/fp/has";
import identity from "lodash/fp/identity";
import keyBy from "lodash/fp/keyBy";
import pick from "lodash/fp/pick";
import values from "lodash/fp/values";

import { getFilteredOptions } from "utils";

const makeAllPossibleNestedFieldsToFlatArray = flatMap(identity);

const getFieldAndSubFields = (field) => {
  return [
    field,
    ...flow((data) => {
      return [
        ...getOr([], ["props", "fields"])(data),
        ...getOr([], ["fields"])(data),
      ];
    }, makeAllPossibleNestedFieldsToFlatArray)(field),
  ];
};

const getSelectedOption = ({ userChoiceValues, value }) =>
  flow((field) => {
    if (has("checkedValue")(field)) {
      // if checkbox (ie. no options array for field)
      return [
        {
          imageURLValue: field.checkedImageURLValue,
          label: field.checkedLabel,
          value: field.checkedValue,
        },
        {
          imageURLValue: field.uncheckedImageURLValue,
          label: field.uncheckedLabel,
          value: field.uncheckedValue,
        },
      ];
    }
    return getFilteredOptions({
      options: field.options || [],
      userChoiceValues,
    });
  }, find({ value }));

export function getSelectedFieldValue(userChoiceValues) {
  return (field) => {
    const value = userChoiceValues[field.name];

    // NOTE:
    // getFilteredOptions is required as some options have the same value
    // see colours in GoalieSticks
    const selectedOption = getSelectedOption({ userChoiceValues, value })(
      field
    );

    return [
      {
        name: field.name,
        label: field.label,
        value,
        ...field,
        // selectedOption: {
        //   images: {},
        //   priceAdjust: 0,
        //   ...selectedOption,
        // },
        selectedOption,
      },

      ...getSelectedFieldValues(userChoiceValues)(selectedOption),
    ];
  };
}

export function getSelectedFieldValues(userChoiceValues) {
  return flow(
    getOr([], ["fields"]),
    flatMap(getFieldAndSubFields),
    flatMap(getSelectedFieldValue(userChoiceValues))
  );
}

export default function selectUserChoices(state) {
  const { selectedProductId, userChoiceValues = {} } = state.app;

  return flow(
    getOr([], ["app", "formData", "products"]),
    find(({ id }) => id === selectedProductId),
    pick(["sizes", "customisations"]),
    flatMap(values),
    flatMap(getSelectedFieldValues(userChoiceValues)),
    keyBy("name")
  )(state);
}
